<template>
    <div>
        <!-- <div v-show="column.field===&quot;warn&quot;"> -->
        <span v-text-lbl="'meetingReceipt'" :style="{ color: transTime(row.startTime, row.endTime) === '未开始' ? '#409efe' : '#909399', cursor: transTime(row.startTime, row.endTime) === '未开始' ? 'pointer' : 'default' }" style="margin-right: 10px" @click="transTime(row.startTime, row.endTime) === '未开始' ? hyhuizhi(row) : ''">会议回执</span>
        <span v-text-lbl="'transfer'" :style="{ color: transTime(row.startTime, row.endTime) === '未开始' ? '#409efe' : '#909399', cursor: transTime(row.startTime, row.endTime) === '未开始' ? 'pointer' : 'default' }" @click="transTime(row.startTime, row.endTime) === '未开始' ? Reassignment(row) : ''">转派</span>
        <!-- <div @click="hyhuizhi">会议回执</div>
    <div @click="Reassignment()">转派</div> -->
        <!-- <hyhuizhi :current-row="currentRow" :is-show="isShow" /> -->
        <!-- 会议回执单 -->
        <el-dialog v-if="isShow" v-el-drag-dialog title="回执" :visible.sync="isShow" :close-on-click-modal="false" width="1000px">
            <el-form ref="changeForm" :rules="rules" :model="replayVo" style="margin: 10px 0px; text-align: center">
                <div class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'isAttend'">是否参会</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="分组名称" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-radio-group v-model="radio">
                                                    <el-radio v-text-lbl="'common.yes'" label="1">是</el-radio>
                                                    <el-radio v-text-lbl="'common.no'" label="2">否</el-radio>
                                                </el-radio-group>
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <tr v-if="radio === '1'" key="radio">
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required"></span>
                                        <span v-field-lbl="'substitutePersonnel'">替会人员</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <el-input v-model="replayVo.dmeetName" v-select-dialog="'staff'" type="input" multiple="false" :root-org-code="loginUser.orgCode" name="recUser" :placeholder="$tx('hygl.components.substitutePersonnelPlaceholder', '请选择替会人员')">
                                            <!-- :org-id="row.orgFullId.split('-')[1]" -->
                                        </el-input>
                                        <!-- <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="替会人员" rules="required">
                      <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                        <el-input
                          v-model="replayVo.recUser"
                          v-select-dialog="'staff'"
                          type="input"
                          multiple="false"
                          :root-org-code="loginUser.orgCode"
                          name="recUser"
                          placeholder="请选择替会人员"
                          :org-id="row.orgFullId.split('-')[1]"
                        >
                        </el-input>
                      </el-tooltip>
                    </ValidationProvider> -->
                                    </td>
                                </tr>
                                <tr v-if="radio === '2'" key="radio1">
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'notAttendingReason'">不参会原因</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="不参会原因" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-model="replayVo.regReason" type="textarea" :placeholder="$tx('hygl.components.notAttendingReasonPlaceholder', '请输入不参会原因')" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
            <!-- <button v-show="anniu" v-select-dialog="'staff'" class="xzry" multiple="true" :root-org-code="loginUser.orgCode" name="Share"></button> -->
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'close'" :icon="'el-icon-close'" :disabled="doing" @click="close">关 闭</el-button>
                <el-button v-pageBtn-lbl="'submit'" type="primary" :disabled="doing" :icon="'el-icon-check'" @click="SignforConfirm">提 交</el-button>
            </span>
        </el-dialog>
        <!-- 转派 -->
        <el-dialog v-if="zpisShow" v-el-drag-dialog :title="$tx('hygl.components.transfer', '转派')" :visible.sync="zpisShow" :close-on-click-modal="false" width="1000px">
            <el-form ref="changeFormzp" :rules="ruleszp" :model="rows" style="margin: 10px 0px; text-align: center">
                <div class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr key="radio2">
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        <span v-text-lbl="'transferer'">转派人员</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="转派人员" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-model="rows.turnsendName" v-select-dialog="'staff'" type="input" multiple="false" :root-org-code="loginUser.orgCode" name="recUser" :placeholder="$tx('hygl.components.transfererPlaceholder', '请选择转派人员')"></el-input>
                                                <!-- :org-id="row.orgFullId.split('-')[1]" -->
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <tr key="radio3">
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        <span v-text-lbl="'transferReason'">转派原因</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="转派原因" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-model="rows.tsReason" type="textarea" :placeholder="$tx('hygl.components.transferReasonlaceholder', '请输入转派原因')" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
            <!-- <button v-show="anniu" v-select-dialog="'staff'" class="xzry" multiple="true" :root-org-code="loginUser.orgCode" name="Share"></button> -->
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'close'" :icon="'el-icon-close'" :disabled="doing" @click="closezp">关 闭</el-button>
                <el-button v-pageBtn-lbl="'submit'" type="primary" :disabled="doing" :icon="'el-icon-check'" @click="zpConfirm">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
// import hyhuizhi from './components/hyhuizhi'
const moment = require('moment')
export default {
    filters: {
        warnCart(val) {
            if (val === 0) {
                return '未超期'
            } else if (val === 1) {
                return '即将超期'
            } else if (val === 2) {
                return '已超期'
            }
        }
    },
    components: {
        // hyhuizhi
    },
    props: {
        row: {
            type: Object,
            default: function () {
                return {}
            }
        },
        index: { type: Number, default: 0 },
        column: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'components',
            currentRow: {},
            isShow: false,
            zpisShow: false,
            loginUser: this.$store.getters.loginUser,
            replayVo: {},
            radio: '1',
            rows: {}
            // row: {}
        }
    },
    computed: {},
    watch: {
        radio(val) {
            if (val === '1') {
                this.replayVo.regReason = null
            }
            if (val === '2') {
                this.replayVo.dmeetName = null
                this.replayVo.dmeetId = null
            }
        }
    },
    created() {},
    beforeDestroy() {},
    mounted() {
        // if (this.column.field === 'FillReport') {
        //     // console.log('打开', this.row)
        //     this.gethbTime()
        // }
    },
    methods: {
        transTime(start, end) {
            var date = new Date()

            var startTime = new Date(start)
            var endTime = new Date(end)
            if (startTime > date) {
                return '未开始'
            } else if (endTime < date) {
                return '已结束'
            } else if (startTime < date) {
                return '进行中'
            }
        },
        hyhuizhi(row) {
            // debugger
            // this.currentRow = row
            this.row = row
            this.isShow = true

            console.log('回执', row)
        },
        Reassignment(row) {
            this.zpisShow = true
        },
        SignforConfirm() {
            var _this = this
            // this.row.regStatus = this.radio
            // this.row.regReason = this.replayVo.regReason
            this.$set(this.replayVo, 'regStatus', this.radio)
            this.$set(this.replayVo, 'meetId', this.row.id)
            this.$set(this.replayVo, 'personId', this.row.personId)
            this.$refs.changeForm.formValidate(async (isOk) => {
                if (!this.replayVo.regReason && _this.radio === '2') {
                    _this.$alert(_this.$tx('hygl.message.reasonNeed', '不参会原因是必须的'), _this.$tx('common.operationTip', '操作提示'), {
                        type: 'warning'
                    })
                    return
                }

                _this
                    .$http({
                        method: 'PUT',
                        url: '/hygl/meetPeople/updateTurnSend',
                        data: _this.replayVo
                    })
                    .then((res) => {
                        console.log(999, res)
                        if (res.code === 'success') {
                            _this.isShow = false
                            _this.replayVo = {}
                            // console.log('会议回执提交')
                            _this.$bus.emit('refreshListData')
                            _this.$message.success(res.message)
                        } else {
                            _this.$message.error(res.message)
                        }
                    })
            })
        },
        zpConfirm() {
            var _this = this
            this.$set(this.rows, 'meetId', this.row.id)
            this.$set(this.rows, 'personId', this.row.personId)
            this.$set(this.rows, 'regStatus', 3)
            this.$set(this.rows, 'signStatus', 0)
            var times = moment(new Date()).format('YYYY-MM-DD HH:mm')
            this.$set(this.rows, 'turensendTime', times)
            this.$refs.changeFormzp.formValidate(async (isOk) => {
                if (!this.rows.turnsendName) {
                    _this.$alert(_this.$tx('hygl.message.transferNeed', '转派人员是必须的'), _this.$tx('common.operationTip', '操作提示'), {
                        type: 'warning'
                    })
                    return
                }
                if (!this.rows.tsReason) {
                    _this.$alert(_this.$tx('hygl.message.transferReasonNeed', '转派原因是必须的'), _this.$tx('common.operationTip', '操作提示'), {
                        type: 'warning'
                    })
                    return
                }

                _this
                    .$http({
                        method: 'PUT',
                        url: '/hygl/meetPeople/updateTurnSend',
                        data: _this.rows
                    })
                    .then((res) => {
                        console.log(999, res)
                        if (res.code === 'success') {
                            _this.zpisShow = false
                            _this.rows = {}
                            console.log('转派提交')
                            _this.$bus.emit('refreshListData')
                            _this.$message.success(res.message)
                        } else {
                            _this.$message.error(res.message)
                        }
                    })
            })
        },
        onSelectStaffCompleted(selectNodes, attr) {
            console.log('选择人', selectNodes)
            let name = ''
            let ids = ''
            let dept = ''
            let deptId = ''
            let mobile = ''
            let email = ''
            let account = ''
            let orgFullOrderNo = ''
            let positionName = ''
            // const list = []
            for (var i = 0; i < selectNodes.length; i++) {
                if (name !== '') name += '、'
                if (ids !== '') ids += '、'
                if (dept !== '') dept += '、'
                if (deptId !== '') deptId += '、'
                if (mobile !== '') mobile += '、'
                if (email !== '') email += '、'
                if (account !== '') account += '、'
                name += selectNodes[i].name
                ids += selectNodes[i].personId
                mobile += selectNodes[i].mobile
                email += selectNodes[i].email
                account += selectNodes[i].account
                positionName += selectNodes[i].positionName
                dept += selectNodes[i].orgFullName.split('-')[1]
                deptId += selectNodes[i].orgFullId.split('-')[1]
                orgFullOrderNo += selectNodes[i].orgFullOrderNo.split('-')[1]
            }
            if (this.isShow) {
                this.$set(this.replayVo, 'dmeetName', name)
                this.$set(this.replayVo, 'dmeetId', ids)
            }
            if (this.zpisShow) {
                this.$set(this.rows, 'phone', mobile)
                this.$set(this.rows, 'userPost', positionName)
                this.$set(this.rows, 'userDept', dept)
                this.$set(this.rows, 'email', email)
                this.$set(this.rows, 'userAccount', account)
                this.$set(this.rows, 'orgFullOrderNo', orgFullOrderNo)
                this.$set(this.rows, 'turnsendName', name)
                this.$set(this.rows, 'turnsendId', ids)
            }
            // this.$set(this.replayVo, 'recDept', dept)
            // this.$set(this.replayVo, 'recDeptId', deptId)
            // // eslint-disable-next-line no-redeclare
            // for (let i = 0; i < selectNodes.length; i++) {
            //     const newobj = {}
            //     const obj = selectNodes[i]
            //     newobj.dmeetId = obj.id
            //     newobj.dmeetName = obj.name
            //     newobj.personId = obj.personId
            //     this.list = newobj
            // }
            // console.log('选到的', this.list)
            // this.row.dmeetName = this.list.dmeetName
            // this.row.dmeetId = this.list.dmeetId
            // this.row.personId = this.list.personId
            // this.row.recDept = this.replayVo.recDept
            // this.row.recDeptId = this.replayVo.recDeptId
            // console.log(777, this.row)
        },
        close() {
            this.isShow = false
            this.replayVo = {}
        },
        closezp() {
            this.zpisShow = false
            this.rows = {}
        }
    }
}
</script>

<style scoped lang="scss">
.caozuo {
    cursor: pointer;
    color: #3399ff;
}
</style>
